function positiveInteger(value) {
  const number = Number(value);
  return Number.isInteger(number) && number > 0 ? number : null;
}

export function hasTransportWeight(entry) {
  if (!entry || typeof entry !== "object") return false;
  const kilograms = positiveInteger(entry.total_weight_kg);
  return kilograms !== null &&
    (entry.weight_display_unit === "kg" || entry.weight_display_unit === "ton");
}

export function hasAnyTransportWeight(entries) {
  return Array.isArray(entries) && entries.some(hasTransportWeight);
}

export function formatTransportWeight(entry) {
  if (!hasTransportWeight(entry)) return "-";
  const kilograms = Number(entry.total_weight_kg);
  if (entry.weight_display_unit === "ton") {
    return `${
      (kilograms / 1000).toLocaleString("nl-NL", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 3,
      })
    } ton`;
  }
  return `${kilograms.toLocaleString("nl-NL")} kg`;
}
